angular.module("avant.customer_applications.directives").directive "amountPromo", [
  "CustomerApplicationService", (CustomerApplicationService) ->
    restrict: "A"
    require: 'ngModel'
    link: ($scope, element, attributes, ngModel) ->

      regexValidation = (regex, value) ->
        re = new RegExp(regex)
        !!(value && re.test(value))

      eligibleToInputPromo = ->
        ($scope.promotions?.length == 0 ) ||
          ($scope.promotions?.length > 0 && !$scope.promotions[0]?.stop_rule_processing?)

      ssnValidation = (validation) ->
        regexValidation(validation, $scope.person.ssn)

      alphaNumericValidation = (validation, value) ->
        regexValidation(validation, value)

      promo_validations =
        ssn_validation: ssnValidation
        alpha_numeric_validation: alphaNumericValidation

      isValid = (key, validation, value) ->
        promo_validations[key](validation, value)

      validatePromotion = (model, value) ->
        return unless value
        return unless eligibleToInputPromo()
        $scope.promotion_result = null
        $scope.promotion_validation_error = null

        valueValid = true
        for key, validation of model.promo_validations
          if valueValid
            if !isValid(key, validation, value)
              $scope.promotion_validation_error = key
              valueValid = false
        if valueValid then addPromotion(value)

      addPromotion = (couponCode) ->
        return if $scope.lockAddPromotion
        $scope.lockAddPromotion = true
        CustomerApplicationService.updateData(
          $scope.page, { person: { ssn: $scope.person.ssn } }, true
        ).then(() ->
          CustomerApplicationService.addPromotion(couponCode)
        ).then((response) ->
          return if couponCode != $scope.new_promotion.coupon_code
          if response.data.error
            $scope.promotion_result =
              type: 'error'
              message: response.data.error
          else
            promotion = response.data.promotion
            $scope.promotion_result =
              type: 'success'
              message: promotion.application_message
            $scope.new_promotion.coupon_code = null
            $scope.promotions.push promotion
            $scope.hidePromoInputField = true if promotion.stop_rule_processing
        ).finally(() ->
          $scope.lockAddPromotion = false
        )

      requirements = $scope.requirements[attributes.ngModel]

      $scope.$watch attributes.ngModel, (newVal, oldVal) ->
        return if newVal == oldVal
        validatePromotion(requirements, newVal)

      $scope.$watch "person.ssn", (newVal, oldVal) ->
        return if newVal == oldVal
        return unless $scope.new_promotion?.coupon_code
        validatePromotion(requirements, $scope.new_promotion.coupon_code)
]
